import { FC, ReactNode } from 'react';

interface LayoutProps {
  children: ReactNode;
}

export const Layout: FC<LayoutProps> = ({ children }) => {
  return <div className="container mx-auto h-screen max-h-screen w-screen max-w-screen">{children}</div>;
};
